import React from 'react';
import { useSelector } from 'react-redux';

import {
  TopNavContainer,
  LeftNavDiv,
  RightNavDiv,
  Logo,
} from './top-nav.style';
import gtzLogo from '../../../../assets/gtz-logo.svg';
import UserNavMenu from './user-nav-menu';

const TopNav = () => {
  const user = useSelector((store) => store.oidc.user);

  return (
    <TopNavContainer>
      <LeftNavDiv>
        <Logo src={gtzLogo} />
      </LeftNavDiv>

      <RightNavDiv>
        {user && <UserNavMenu user={user} />}
      </RightNavDiv>
    </TopNavContainer>
  );
};

export default TopNav;
